export function generateSOAPList(cnDisplaySettings, advancedSoapTitles, requiredComponents) {
  return {
    subjective: (cnDisplaySettings?.sections?.soap?.subjective?.enabled ||
      requiredComponents?.includes('subjective')) && {
      title: 'Subjective',
      path: 'subjective',
      position: cnDisplaySettings?.sections?.soap?.subjective?.position
    },
    objective: (cnDisplaySettings?.sections?.soap?.objective?.enabled ||
      requiredComponents?.includes('objective')) && {
      title: 'Objective',
      path: 'objective',
      position: cnDisplaySettings?.sections?.soap?.objective?.position
    },
    assessment: (cnDisplaySettings?.sections?.soap?.assessment?.enabled ||
      requiredComponents?.includes('assessment')) && {
      title: 'Assessment',
      path: 'assessment',
      position: cnDisplaySettings?.sections?.soap?.assessment?.position
    },
    plan: (cnDisplaySettings?.sections?.soap?.plan?.enabled ||
      requiredComponents?.includes('plan')) && {
      title: 'Plan',
      path: 'plan',
      position: cnDisplaySettings?.sections?.soap?.plan?.position
    },
    medications: cnDisplaySettings?.sections?.soap?.medications?.enabled && {
      title: 'Medications',
      path: 'medicationHistory',
      position: cnDisplaySettings?.sections?.soap?.medications?.position
    },
    vitals: cnDisplaySettings?.sections?.soap?.vitals?.enabled && {
      title: 'Vitals',
      path: 'vitals',
      position: cnDisplaySettings?.sections?.soap?.vitals?.position
    },
    ...advancedSoapTitles,
    cptCodes: cnDisplaySettings?.sections?.soap?.cptCodes?.enabled && {
      title: 'CPT® Codes',
      path: 'cpt-codes',
      position: cnDisplaySettings?.sections?.soap?.cptCodes?.position
    },
    diagnosisCodes: cnDisplaySettings?.sections?.soap?.diagnosisCodes?.enabled && {
      title: 'Diagnosis Codes',
      path: 'diagnosis-codes',
      position: cnDisplaySettings?.sections?.soap?.diagnosisCodes?.position
    },
    notes: cnDisplaySettings?.sections?.soap?.notes?.enabled && {
      title: 'General Notes',
      path: 'notes',
      position: cnDisplaySettings?.sections?.soap?.notes?.position
    },
    orders: cnDisplaySettings?.sections?.soap?.orders?.enabled && {
      title: 'Orders',
      path: 'orders',
      position: cnDisplaySettings?.sections?.soap?.orders?.position
    },
    goals: cnDisplaySettings?.sections?.soap?.goals?.enabled && {
      title: 'Goals',
      path: 'goals',
      position: cnDisplaySettings?.sections?.soap?.goals?.position
    },
    patientNeeds: cnDisplaySettings?.sections?.soap?.patientNeeds?.enabled && {
      title: 'Patient Needs / Presenting Issues',
      path: 'patient-needs',
      position: cnDisplaySettings?.sections?.soap?.patientNeeds?.position
    },
    problemManifestationDefinition: cnDisplaySettings?.sections?.soap
      ?.problemManifestationDefinition?.enabled && {
      title: 'Problem Manifestation / Definition',
      path: 'problem-manifestation-definition',
      position: cnDisplaySettings?.sections?.soap?.problemManifestationDefinition?.position
    }
  };
}
